export default {"src":"/_next/static/media/illu-header.7d2c9cb5.svg","height":474,"width":494};